import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const newSegmentMessages = defineMessages({
  durationRequired: {
    id: 'segments.new.form.duration.required',
    defaultMessage: 'The duration is required'
  },
  distanceRequired: {
    id: 'segments.new.form.distance.required',
    defaultMessage: 'The distance is required'
  }
})

export const newSegmentSchema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    companyLineSpecs: yup.array().of(
      yup.object().shape({
        distance: yup.string().required(intl.formatMessage(newSegmentMessages.distanceRequired)),
        duration: yup.string().required(intl.formatMessage(newSegmentMessages.durationRequired)),
        realDistance: yup.string()
      })
    )
  })
}
